export default "__VITE_ASSET__BIDbj5H7__"